var _rect, _path, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssortmentFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 6.4,
    height: 6.4,
    rx: 3.2,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6137 7.62815L15.2766 2.95406C15.0801 2.56096 14.5191 2.56096 14.3226 2.95406L11.9855 7.62815C11.8082 7.98277 12.0661 8.4 12.4626 8.4H17.1367C17.5331 8.4 17.791 7.98277 17.6137 7.62815Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5996,
    y: 12.495,
    width: 6.4,
    height: 5.33333,
    rx: 2.66667,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.39941,
    y: 12,
    width: 5.6001,
    height: 5.6001,
    rx: 0.995573,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.40936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssortmentFilledV2);
export default __webpack_public_path__ + "static/media/assortmentFilledV2.f093224307a3605eebebb1fde7acd54a.svg";
export { ForwardRef as ReactComponent };